import { useTranslation } from 'react-i18next';

export default function CaseStudySection({ title, children, label }) {
  const { t } = useTranslation();
  const safeId = title
    ? title.replace(/\s+/g, '-').toLowerCase().replace(/[^a-z0-9-]/g, '')
    : 'section';

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" aria-labelledby={`section-${safeId}`}>
      <div className="grid grid-cols-12 gap-8 mb-8">
        <div className="col-span-12 md:col-span-4">
          {label && (
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4" aria-hidden="true">
              {label}
            </div>
          )}
          <h2 id={`section-${safeId}`} className="font-display text-3xl md:text-4xl uppercase leading-tight">
            {title}
          </h2>
        </div>
        <div className="col-span-12 md:col-span-7 md:col-start-6">
          {children}
        </div>
      </div>
    </section>
  );
}
